import { useState, useMemo } from "react";

import { normalizeScoreMatrix } from "../Matrix/utils";
import { ScoreData } from "../types";

const useMatrixPagination = (beforeScore?: ScoreData, afterScore?: ScoreData) => {
  const [currentPage, setCurrentPage] = useState(0);

  const maxPages = useMemo(() => {
    const beforeLength = normalizeScoreMatrix(beforeScore?.score_matrix).length;
    const afterLength = normalizeScoreMatrix(afterScore?.score_matrix).length;
    return Math.max(beforeLength, afterLength);
  }, [beforeScore, afterScore]);

  const handlePrevPage = () => {
    setCurrentPage((prev: number) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNextPage = () => {
    setCurrentPage((prev: number) => (prev < maxPages - 1 ? prev + 1 : prev));
  };

  return { currentPage, maxPages, handlePrevPage, handleNextPage };
};

export default useMatrixPagination;
